import { AxiosInstance, AxiosResponse } from 'axios';
import createRequest from '../createRequest';
import { filteredNullFromResponse } from '@/utils/filteredNullFromResponse';
import { mdapResponseInterceptors } from '@/utils/mdap/reporter';
import { apiInterceptors } from '@/utils/report';
import { getHelpHost } from '@/utils/locale';

export const baseURL = `${getHelpHost()}/api/inhouse/`;

export const fetch: AxiosInstance = createRequest({ baseURL });


const handleSuccess = (response: AxiosResponse): Promise<AxiosResponse<any>> => {
  const { status, data: res } = response;
  apiInterceptors(response);
  mdapResponseInterceptors(response);
  if (status === 200 && res) {
    return Promise.resolve(filteredNullFromResponse(res));
  } else {
    const error = new Error(`Request failed with status code ${status || 'UNKNOWN'}`);
    ((error as unknown) as any).response = response;
    return Promise.reject(error);
  }
};

const handleError = (err: any) => {
  apiInterceptors(err);
  return Promise.reject(err);
};

fetch?.interceptors?.request?.use?.(config => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  config.requestStartTime = Date.now();
  return config;
});

fetch?.interceptors?.response?.use?.(handleSuccess, handleError);
